import { Link } from 'react-router-dom';

const featuredCases = [
  {
    id: 'rihe-restaurant',
    tag: '餐飲空間',
    title: '日禾和食',
    subtitle: '品牌禪意日式餐廳空間設計',
    area: '台北市信義區・180坪',
    img: 'https://readdy.ai/api/search-image?query=elegant%20japanese%20restaurant%20interior%20design%20zen%20minimalist%20warm%20wood%20stone%20floor%20soft%20ambient%20lighting%20peaceful%20dining%20atmosphere%20commercial%20space%20neutral%20tones&width=800&height=600&seq=case001&orientation=landscape',
  },
  {
    id: 'horizon-showroom',
    tag: '展示接待',
    title: 'Horizon 品牌展廳',
    subtitle: '高端建材品牌旗艦展示空間',
    area: '台北市內湖區・250坪',
    img: 'https://readdy.ai/api/search-image?query=luxury%20brand%20showroom%20exhibition%20space%20interior%20design%20high-end%20materials%20display%20architectural%20lighting%20dramatic%20open%20space%20sophisticated%20gallery%20style&width=800&height=600&seq=case005hp&orientation=landscape',
  },
];

const gridCases = [
  {
    id: 'zhixuan-retail',
    tag: '零售門市',
    title: '質選良品',
    area: '台中市西區・90坪',
    img: 'https://readdy.ai/api/search-image?query=modern%20lifestyle%20boutique%20retail%20store%20interior%20design%20clean%20white%20walls%20wooden%20display%20shelves%20soft%20spotlight%20commercial%20minimalist%20space%20premium%20goods%20display&width=800&height=600&seq=case002&orientation=landscape',
  },
  {
    id: 'lumia-clinic',
    tag: '診所醫美',
    title: 'Lumia 醫美診所',
    area: '台北市大安區・65坪',
    img: 'https://readdy.ai/api/search-image?query=luxury%20medical%20aesthetic%20clinic%20interior%20design%20marble%20reception%20desk%20soft%20warm%20lighting%20clean%20white%20walls%20premium%20healthcare%20space%20sophisticated%20atmosphere&width=800&height=600&seq=case003&orientation=landscape',
  },
  {
    id: 'nova-office',
    tag: '辦公空間',
    title: 'NOVA 創意工作室',
    area: '台北市松山區・120坪',
    img: 'https://readdy.ai/api/search-image?query=modern%20creative%20studio%20office%20interior%20design%20open%20workspace%20natural%20light%20exposed%20concrete%20ceiling%20warm%20wood%20furniture%20collaborative%20zone%20brand%20agency%20space&width=800&height=600&seq=case004&orientation=landscape',
  },
  {
    id: 'lekafe-chain',
    tag: '餐飲空間',
    title: 'Le Kafé 精品咖啡',
    area: '高雄市前金區・55坪',
    img: 'https://readdy.ai/api/search-image?query=premium%20specialty%20coffee%20shop%20interior%20design%20warm%20wood%20counter%20exposed%20brick%20wall%20pendant%20lights%20cozy%20atmosphere%20brand%20cafe%20minimalist%20elegant&width=800&height=600&seq=case006&orientation=landscape',
  },
];

export default function CasesPreview() {
  return (
    <section className="py-24 md:py-32 bg-[#fafaf8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Case Studies</p>
            <h2
              className="font-bold text-[#1a1a1a] leading-[1.35]"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              精選作品案例
            </h2>
            <p className="text-[#5a5a5a] mt-3 max-w-lg" style={{ fontSize: '1.1875rem' }}>
              每個案例背後，都是一段深度的品牌空間策略實踐歷程。
            </p>
          </div>
          <Link
            to="/cases"
            className="inline-flex items-center gap-2 text-[#b8956a] font-medium hover:gap-3 transition-all cursor-pointer whitespace-nowrap text-[1rem]"
          >
            查看全部 8 個案例
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Featured Row — 2 large cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-5 md:mb-6">
          {featuredCases.map((c) => (
            <Link
              key={c.id}
              to={`/cases/${c.id}`}
              className="group relative overflow-hidden rounded-2xl cursor-pointer block"
            >
              <div className="w-full h-[360px] md:h-[440px]">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent"></div>

              <div className="absolute top-5 left-5">
                <span className="px-3 py-1 bg-[#b8956a] text-white text-xs font-medium rounded-full">
                  {c.tag}
                </span>
              </div>

              <div className="absolute top-5 right-5 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-white text-sm"></i>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-7">
                <h3
                  className="text-white font-semibold mb-1.5 leading-[1.4]"
                  style={{ fontSize: '1.25rem' }}
                >
                  {c.title}
                </h3>
                <p className="text-white/65 text-sm mb-3">{c.subtitle}</p>
                <p className="text-white/50 text-xs flex items-center gap-1.5">
                  <i className="ri-map-pin-line"></i>
                  {c.area}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {/* Grid Row — 4 smaller cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {gridCases.map((c) => (
            <Link
              key={c.id}
              to={`/cases/${c.id}`}
              className="group relative overflow-hidden rounded-xl cursor-pointer block"
            >
              <div className="w-full h-[200px] md:h-[240px]">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent"></div>

              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-0.5 bg-[#b8956a] text-white text-xs font-medium rounded-full">
                  {c.tag}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3
                  className="text-white font-semibold leading-[1.4] mb-1"
                  style={{ fontSize: '1rem' }}
                >
                  {c.title}
                </h3>
                <p className="text-white/50 text-xs flex items-center gap-1">
                  <i className="ri-map-pin-line"></i>
                  {c.area}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
